import * as t from './actionTypes';

export const initialState = {
  isFetchingMessageTypesAndSenders: false,
  isTemplateAsyncProcessing: false,
  projects: [] as Record<string, any>[],
  previewThumbnails: {},
  rootFolderId: 0,
  copyTemplateData: {
    destTemplateId: null,
    destProjectId: null,
    srcTemplateId: null,
  },
};

const templateIndexReducer = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case t.IS_TEMPLATE_ASYNC_PROCESSING:
      return {
        ...state,
        isTemplateAsyncProcessing: action.isAsyncProcessing,
      };
    case t.GET_MESSAGETYPES_AND_SENDERS_REQUEST:
      return {
        ...state,
        isFetchingMessageTypesAndSenders: true,
      };

    case t.GET_MESSAGETYPES_AND_SENDERS_ERROR:
      return {
        ...state,
        isFetchingMessageTypesAndSenders: false,
      };

    case t.GET_MESSAGETYPES_AND_SENDERS_RESPONSE:
      return {
        ...state,
        isFetchingMessageTypesAndSenders: false,
        projects: {
          ...state.projects,
          [action.projectId]: {
            ...state.projects[action.projectId],
            [action.messageMedium]: {
              messageTypes: action.messageTypes,
              emailSenders: action.emailSenders,
              smsSenders: action.smsSenders,
              whatsAppSenders: action.whatsAppSenders,
            },
          },
        },
      };

    case t.GET_TEMPLATE_PREVIEW_THUMBNAILS_RESPONSE:
      return {
        ...state,
        previewThumbnails: {
          ...state.previewThumbnails,
          ...action.result,
        },
      };

    case t.FETCH_ROOT_FOLDER_ID_RESPONSE:
      return {
        ...state,
        rootFolderId: action.rootFolderId,
      };

    case t.COPY_TEMPLATE_REQUEST:
      return {
        ...state,
        copyTemplateData: {
          srcTemplateId: action.srcTemplateId,
          destTemplateId: undefined,
          destProjectId: undefined,
        },
      };
    case t.COPY_TEMPLATE_RESPONSE:
      return {
        ...state,
        copyTemplateData: {
          destTemplateId: action.destTemplateId,
          srcTemplateId: action.srcTemplateId,
          destProjectId: action.destProjectId,
        },
      };
    default:
      return state;
  }
};

export default templateIndexReducer;
